import React from 'react'
import PropTypes from 'prop-types'
import { Link, Text } from 'shared/components'

import * as styles from './styles'

const TransitionLinkComponent = ({ text, linkText, to, size = 16 }) => (
  <Text white size={size}>
    {text}&nbsp;
    <Link to={to} css={styles.link}>
      {linkText}
    </Link>
  </Text>
)

TransitionLinkComponent.propTypes = {
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  size: PropTypes.number,
}

export default TransitionLinkComponent
